import { Amplify } from '@aws-amplify/core';

// Configure Amplify with Cognito
export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      region: process.env.REACT_APP_COGNITO_REGION,
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
      oauth: {
        domain: process.env.REACT_APP_COGNITO_DOMAIN,
        scope: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
        redirectSignIn: window.location.origin,
        redirectSignOut: window.location.origin,
        responseType: 'code'
      }
    }
  });
};

export default {
  configureAmplify
};
